import { reactive } from 'vue';
import { watchOnce } from '@vueuse/core';

import { isFeatureToggleActive } from '../customFeatureToggles';

export type StatsigExperimentName =
  | 'summary_button_experiment'
  | 'hotel_details_room_cards_grid_layout'
  | 'hotel_selection_sembo_benefits'
  | 'new_price_calendar'
  | 'hotel_guest_rating'
  | 'calendar_without_prices_in_car_trip'
  | 'see_all_product_copy';

interface StatsigExperimentState {
  value: boolean;
  isLoaded: boolean;
}

type StatsigExperiments = Record<StatsigExperimentName, StatsigExperimentState>;

const statsigExperiments = reactive<StatsigExperiments>({
  summary_button_experiment: { value: false, isLoaded: false },
  hotel_details_room_cards_grid_layout: { value: false, isLoaded: false },
  hotel_selection_sembo_benefits: { value: false, isLoaded: false },
  new_price_calendar: { value: false, isLoaded: false },
  hotel_guest_rating: { value: false, isLoaded: false },
  calendar_without_prices_in_car_trip: { value: false, isLoaded: false },
  see_all_product_copy: { value: false, isLoaded: false },
});

export function assignExperimentValue(
  experimentName: StatsigExperimentName,
  value: boolean
): void {
  statsigExperiments[experimentName].value = value;
  statsigExperiments[experimentName].isLoaded = true;
}

export async function isExperimentAsync(
  experimentName: StatsigExperimentName
): Promise<boolean> {
  return new Promise((resolve) => {
    if (isFeatureToggleActive(experimentName)) {
      resolve(true);
    } else if (isFeatureToggleActive(`!${experimentName}`)) {
      resolve(false);
    } else if (statsigExperiments[experimentName].isLoaded) {
      resolve(statsigExperiments[experimentName].value);
    } else {
      watchOnce(
        () => statsigExperiments[experimentName].isLoaded,
        async () => resolve(statsigExperiments[experimentName].value)
      );
    }
  });
}
